import { createSlotRecipe } from './runtime';

const tooltipConfig = {"name":"tooltip","slots":["root","trigger","content","title","body"]}

export const tooltip = /* @__PURE__ */ createSlotRecipe(tooltipConfig)